import * as React from 'react';
import './ReturnsDesktop.scss';
import EligibleTab from '../EligibleTab';
import StatusTab from '../StatusTab';
// import DamagedTab from '../DamagedTab';
// import MisshipmentsTab from '../MisshipmentsTab';
import Breadcrumbs from 'src/components/common/Breadcrumbs';
import Tabs from 'src/components/common/Tabs';
import { IEligibleResponse } from 'src/services/returns/typings';
import { IRmaModalData, IToggleModalOptions } from '../../ReturnsView';

interface IReturnsDesktopProps {
  currentTab: number;
  selectTab: (index: number) => void;
  eligibleData: IEligibleResponse;
  handlePaginationEligible: (type: string) => void;
  handleSortItemsEligible: (option: string) => void;
  sortEligible: string[];
  setSortEligible: (values: string[]) => void;
  handleShowCartModal: (status: boolean) => void;
  selectedTypeOfItem: string;
  selectedTypeOfItemStatus: string;
  handleSelectedTypeOfItem: (type: any) => void;
  handleSelectedTypeOfItemStatus: (type: any) => void;
  selectedDates: any;
  setSelectedDates: (date: any) => void;
  handleDateChange: (date: any) => void;
  handleClickSearch: (searchBy: string, query: string) => void;
  handleClickSearchStatus: (searchBy: string, query: string) => void;
  handlePaginationStatus: (type: string) => void;
  handleSortItemsStatus: (option: string) => void;
  sortStatus: string[];
  handleShowRmaModal: (state: boolean, rmaModalData: IRmaModalData) => void;
  setSelectedReturnToDelete: (id: string) => void;
  filter: string;
  setFilter: (value: string) => void;
  handleOpenBarcodeModal: (rmaNumber: string,upsResponseData:any[]) => void;
  showCounter: boolean;
  forItem: string;
  showCounterStatus: boolean;
  forItemStatus: string;
  clearStatusFilters: () => void;
  clearEligibleFilters: () => void;
  toggleModalOptions: IToggleModalOptions;
  t?: any;
  handleDesktopPaginationEligible?(event: any): void;
  handleDesktopPaginationStatus?(event: any): void;
  handlePageSizeChangeEligible?(event: any): void;
  handlePageSizeChangeStatus?(event: any): void;
  handleMenuItemClick: (event: any, index:number) => void;
  handleMenuItemClickReturnStatus: (event: any, index:number) => void;
}

const ReturnsDesktop: React.FC<IReturnsDesktopProps> = props => {
  const {
    currentTab,
    selectTab,
    eligibleData,
    handlePaginationEligible,
    handleSortItemsEligible,
    sortEligible,
    setSortEligible,
    handleShowCartModal,
    selectedTypeOfItem,
    selectedTypeOfItemStatus,
    handleSelectedTypeOfItem,
    handleSelectedTypeOfItemStatus,
    selectedDates,
    setSelectedDates,
    handleDateChange,
    handleClickSearch,
    handleClickSearchStatus,
    handlePaginationStatus,
    handleSortItemsStatus,
    sortStatus,
    handleShowRmaModal,
    setSelectedReturnToDelete,
    filter,
    setFilter,
    showCounter,
    forItem,
    showCounterStatus,
    forItemStatus,
    clearEligibleFilters,
    clearStatusFilters,
    toggleModalOptions,
    handleDesktopPaginationEligible,
    handleDesktopPaginationStatus,
    handlePageSizeChangeEligible,
    handlePageSizeChangeStatus,
    handleMenuItemClick,
    handleMenuItemClickReturnStatus,
    t
  } = props;

  const renderEligibleTab = () => {
    return (
      <EligibleTab
        handlePagination={handlePaginationEligible}
        eligibleData={eligibleData}
        sortBy={sortEligible}
        setSortEligible={setSortEligible}
        handleShowCartModal={handleShowCartModal}
        handleSortItems={handleSortItemsEligible}
        selectedTypeOfItem={selectedTypeOfItem}
        handleSelectedTypeOfItemChange={handleSelectedTypeOfItem}
        selectedDates={selectedDates}
        setSelectedDates={setSelectedDates}
        handleDateChange={handleDateChange}
        handleClickSearch={handleClickSearch}
        showCounter={showCounter}
        forItem={forItem}
        handleChangeTab={selectTab}
        clearFilters={clearEligibleFilters}
        toggleModalOptions={toggleModalOptions}
        handleDesktopPaginationEligible={handleDesktopPaginationEligible}
        handlePageSizeChangeEligible={handlePageSizeChangeEligible}
        handleMenuItemClick={handleMenuItemClick}
      />
    );
  };

  const renderStatusTab = () => {
    return (
      <StatusTab
        handlePagination={handlePaginationStatus}
        sortBy={sortStatus}
        handleSortItemsStatus={handleSortItemsStatus}
        handleShowRmaModal={handleShowRmaModal}
        selectedTypeOfItem={selectedTypeOfItemStatus}
        handleSelectedTypeOfItemChange={handleSelectedTypeOfItemStatus}
        handleClickSearch={handleClickSearchStatus}
        setSortEligible={setSortEligible}
        setSelectedReturnToDelete={setSelectedReturnToDelete}
        filter={filter}
        setFilter={setFilter}
        showCounter={showCounterStatus}
        forItem={forItemStatus}
        clearFilters={clearStatusFilters}
        clearEligibleFilters={clearEligibleFilters}
        handleDesktopPaginationStatus={handleDesktopPaginationStatus}
        handlePageSizeChangeStatus={handlePageSizeChangeStatus}
        handleMenuItemClickReturnStatus={handleMenuItemClickReturnStatus}
      />
    );
  };

  // const renderDamagedTab = () => {
  //   return <DamagedTab />;
  // };

  // const renderMisshipmentsTab = () => {
  //   return <MisshipmentsTab />;
  // };

  return (
    <div className="rp-returns-desktop">
      <Breadcrumbs>
        {t('common.home')} / {t('myReturns.breadCrumbTitle')}{' '}
      </Breadcrumbs>
      <h1 className="rp-return-desktop-title">
        {t('myReturns.breadCrumbTitle')}
      </h1>
      <div className="rp-returns-desktop-tabs">
        <Tabs
          currentTab={currentTab}
          selectTab={selectTab}
          tabTitles={[
            {
              title: `${t('myReturns.eligibleReturns')}`,
              count: 1,
              showCount: false
            },
            {
              title: `${t('myReturns.returnStatus')}`,
              count: 2,
              showCount: false
            }
            // {
            //   title: `${t('myReturns.damageOrDefective')}`,
            //   count: 3,
            //   showCount: false
            // },
            // {
            //   title: `${t('myReturns.misShipments')}`,
            //   count: 4,
            //   showCount: false
            // }
          ]}
          tabContents={[
            renderEligibleTab(),
            renderStatusTab()
            // renderDamagedTab(),
            // renderMisshipmentsTab()
          ]}
        />
      </div>
    </div>
  );
};

export default ReturnsDesktop;
